import { nextTick } from 'vue'

/**
 * 只在内容真正超出可视区域时才滚动到底部。
 * 键盘弹出时容器可视高度会变化，若无脑 scrollTop = scrollHeight，
 * 会把预留给输入框的空白部分也滚入视口，反而把内容较少时的消息顶出屏幕。
 */
export function useAutoScroll(containerRef) {
  const scrollToBottom = async () => {
    await nextTick()
    const el = containerRef.value
    if (!el) return
    if (el.scrollHeight <= el.clientHeight) return
    el.scrollTop = el.scrollHeight
  }

  return { scrollToBottom }
}
